export default __webpack_public_path__ + "static/media/ger.b64fb090.svg";